import { render, staticRenderFns } from "./DocEditor.vue?vue&type=template&id=f20ae6b4&"
import script from "./DocEditor.vue?vue&type=script&lang=js&"
export * from "./DocEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports